'use strict'

const EventEmitter = require('events')
const RFID = require('../lib/RFID')

class RFIDEvents extends EventEmitter {
  constructor(address, options) {
    super()

    this._onAntennaRssiThreshold = parseInt(options?.onAntennaRssiThreshold) || -30
    this._offAntennaRssiThreshold = parseInt(options?.offAntennaRssiThreshold) || -100

    this.rfid = new RFID(address, options)
    this.rfid.on('message', this._onMessage.bind(this))
    this.rfid.on('connect', this._onStatusChange.bind(this))
    this.rfid.on('disconnect', this._onStatusChange.bind(this))

    this._tags = new Map()
    this._currentStatus = this.rfid.getStatus()
  }

  connect() {
    this.rfid.connect()
  }

  disconnect() {
    this.rfid.disconnect()
  }

  getStatus() {
    return this._currentStatus
  }

  getTags() {
    const result = []
    this._tags.forEach(tags => {
      tags.forEach(({id, antenna, side, position}) => {
        result.push({id, antenna, side, position})
      })
    })
    return result
  }

  getTag(tagId) {
    const result = []
    this._tags.forEach(tags => {
      tags.forEach(({id, antenna, side, position}) => {
        if (id === tagId) {
          result.push({id, antenna, side, position})
        }
      })
    })
    return result
  }

  _onMessage(tags) {
    const newTags = []

    tags.forEach(({id, antenna, side, RSSI}) => {
      if (!this._tags.has(antenna)) {
        this._tags.set(antenna, new Map())
      }

      const position = this.getTagPosition(RSSI)
      const previousPosition = this._tags.get(antenna).get(id)?.position || 'off_antenna'

      const tag = {id, antenna, side, position}
      this._tags.get(antenna).set(id, tag)
      newTags.push(tag)

      if (position !== previousPosition) {
        this.emit(`tag_${position}`, {id, antenna, side, position})
      }
    }, this)

    this._tags.forEach(antennaTags => {
      antennaTags.forEach(tag => {
        if (!newTags.includes(tag)) {
          const {id, antenna, side} = tag
          const position = 'off_antenna'

          antennaTags.delete(id)

          if (tag.position !== position) {
            this.emit(`tag_${position}`, {id, antenna, side, position})
          }
        }
      })
    }, this)
  }

  _onStatusChange(data) {
    if (this._currentStatus.status !== data.status) {
      this.emit(data.status, data)
      this._currentStatus = data
    }
  }

  getTagPosition(rssi) {
    if (rssi && rssi >= this._onAntennaRssiThreshold) {
      return 'on_antenna'
    } else if (rssi && rssi > this._offAntennaRssiThreshold) {
      return 'near_antenna'
    } else {
      return 'off_antenna'
    }
  }
}

module.exports = RFIDEvents